(function(){
    'use strict';

    angular.module('entryModalModule', [])
        .controller('entryModalCtrl', ['$scope', '$rootScope', '$location', '$timeout', '$stateParams', 'canvasService', '$compile', 'helpers', 'CANVAS_OPTS', entryModalCtrl]);

    function entryModalCtrl($scope, $rootScope, $location, $timeout, $stateParams, canvasService, $compile, helpers, CANVAS_OPTS){
        $rootScope.$on('displayEntryModal', function(evt, view, connection) {

            // Listener to close modal if user click outside the modal
            $('body, .trigger-panel-modal').on('click', '.modal-dialog', function(e) {
                if ($(e.target).hasClass('modal-dialog')) {
                    $scope.showTriggerPanelModal = false;
                }
            });

            if(!view && !connection) {
                $scope.showTriggerPanelModal = true;
                $scope.showTriggerPanelMenu = true;
                $scope.isWebsiteEngagementFormDisplayed = false;
                $scope.isAddToSegmentFormDisplayed = false;
                $scope.isAddToListFormDisplayed = false;
                $scope.isDateTimeFormDisplayed = false;
                $scope.editView = false;
                $scope.connections = [];
            } else {
                $scope.connections = angular.copy(connection);
                $scope.showTriggerPanelMenu = false;
                $scope.showTriggerPanelModal = true;
                $scope[view] = true;
                $scope.editView = true;
            }
        });

        // Close modal
        $scope.closeTriggerPanelModal = function() {
            $scope.showTriggerPanelModal = false;
            $scope.isWebsiteEngagementFormDisplayed = false;
            $scope.isAddToSegmentFormDisplayed = false;
            $scope.isAddToListFormDisplayed = false;
            $scope.isDateTimeFormDisplayed = false;
        };

        // Show Add To List Form
        $scope.showAddToListForm = function () {
            $scope.isAddToListFormDisplayed = true;
            $scope.showTriggerPanelMenu = false;
        };

        // Show Add To Segment Form
        $scope.showAddToSegmentForm = function () {
            $scope.isAddToSegmentFormDisplayed = true;
            $scope.showTriggerPanelMenu = false;
        };

        // Show Web Site Engagement Form
        $scope.showWebsiteEngagementForm = function () {
            $scope.isWebsiteEngagementFormDisplayed = true;
            $scope.showTriggerPanelMenu = false;
        };

        // Show Specific Date and Time Form
        $scope.showDateTimeForm = function () {
            $scope.isDateTimeFormDisplayed = true;
            $scope.showTriggerPanelMenu = false;
        };

        // Save Join to List
        $scope.saveJoinToListForm = function () {
            $scope.showListSelectionError = false;

            if ($scope.connections.data.selectedList.length === 0) {
                $scope.showListSelectionError = true;
                return;
            }

            if($scope.editView) {
                // Emit the save connections
                $rootScope.$emit('saveEntryData' + $scope.connections.id, $scope.connections);
            } else {
                let now = new Date(),
                    directiveName = 'add-to-list-entry',
                    newScope = $scope.$new(true);

                // to display step 2
                $rootScope.activePlus = true;

                // load the journey
                $scope.connections.id = 'entry_' + now.getTime();
                $scope.connections.top = CANVAS_OPTS.canvasOptions.top;
                $scope.connections.left = CANVAS_OPTS.canvasOptions.left;
                $scope.connections.type = 'Entry';
                $scope.connections.elemClass = {'addToListEntry': 'add-to-list-entry'};
                $scope.connections.elemName = 'AddedToList';
                $scope.connections.color = '#4F4FC9';
                $scope.connections.isRoot = true;
                $scope.connections.isElegibleForUpdate = true;

                $timeout(function () {
                    $rootScope.cElement = $scope.connections;
                    $compile('<' + directiveName + '></' + directiveName + '>')(newScope);
                    $scope.connections.wasSave = true;
                }, 10);

                $timeout(function () {
                    $scope.connections.wasSave = false;
                }, 1500);
            }

            $scope.isAddToListFormDisplayed = false;
            $scope.showTriggerPanelModal = false;
            $scope.hideJourney();
        };

        // Save Join to Segment
        $scope.saveJoinToSegmentForm = function () {
            $scope.showSegmentSelectionError = false;

            if ($scope.connections.data.selectedList.length === 0) {
                $scope.showSegmentSelectionError = true;
                return;
            }

            if($scope.editView) {
                // Emit the save connections
                $rootScope.$emit('saveEntrySegmentData' + $scope.connections.id, $scope.connections);
            } else {
                let directiveName = 'add-to-segment-entry',
                    newScope = $scope.$new(true);

                // to display step 2
                $rootScope.activePlus = true;

                // load the journey
                $scope.connections.top = CANVAS_OPTS.canvasOptions.top;
                $scope.connections.left = CANVAS_OPTS.canvasOptions.left;
                $scope.connections.type = 'Entry';
                $scope.connections.elemClass = {'addToSegmentEntry': 'add-to-segment-entry'};
                $scope.connections.elemName = 'AddedToSegment';
                $scope.connections.color = '#4F4FC9';
                $scope.connections.isRoot = true;
                $scope.connections.isElegibleForUpdate = true;

                $timeout(function () {
                    $rootScope.cElement = $scope.connections;
                    $compile('<' + directiveName + '></' + directiveName + '>')(newScope);
                    $scope.connections.wasSave = true;
                }, 10);

                $timeout(function () {
                    $scope.connections.wasSave = false;
                }, 2000);
            }

            $scope.isAddToSegmentFormDisplayed = false;
            $scope.showTriggerPanelModal = false;
            $scope.hideJourney();
        };

        // Save web site engagement
        $scope.saveWebsiteEngagement = function () {
            $scope.showSpecificUrlError = false;

            if (($scope.connections.data.specificUrl === '' && $scope.connections.data.source !== 'any-tracked-page') || $scope.specificUrlError) {
                $scope.showSpecificUrlError = true;
                return;
            }

            if($scope.editView) {
                // Emit the save connections
                $rootScope.$emit('saveEngagementEntryData' + $scope.connections.id, $scope.connections);
            } else {
                var directiveName = 'website-engagement',
                    newScope = $scope.$new(true);

                // to display step 2
                $rootScope.activePlus = true;

                // load the journey
                // load the journey
                $scope.connections.top = CANVAS_OPTS.canvasOptions.top;
                $scope.connections.left = CANVAS_OPTS.canvasOptions.left;
                $scope.connections.type = 'Entry';
                $scope.connections.elemClass = {'websiteEngagement': 'website-engagement'};
                $scope.connections.elemName = 'WebsiteEngagement';
                $scope.connections.color = '#4F4FC9';
                $scope.connections.isRoot = true;
                $scope.connections.isElegibleForUpdate = true;

                $timeout(function () {
                    $rootScope.cElement = $scope.connections;
                    $compile('<' + directiveName + '></' + directiveName + '>')(newScope);
                    $scope.connections.wasSave = true;
                }, 10);

                $timeout(function () {
                    $scope.connections.wasSave = false;
                }, 2000);
            }

            $scope.isWebsiteEngagementFormDisplayed = false;
            $scope.showTriggerPanelModal = false;
            $scope.hideJourney();
        };

        // Save Join to Segment
        $scope.saveDateTimeForm = function () {
            $scope.showListSelectionError = false;
            $scope.showDateSelectionError = false;
            $scope.showTimeSelectionError = false;

            if ($scope.connections.data.selectedList.length === 0 || $scope.connections.data.time === '' || $scope.connections.data.timezoneName === '') {
                if ($scope.connections.data.selectedList.length === 0) {
                    $scope.showListSelectionError = true;
                }

                if ($scope.connections.data.time === '') {
                    $scope.showDateSelectionError = true;
                }

                if ($scope.connections.data.timezoneName === '') {
                    $scope.showTimeSelectionError = true;
                }

                return;
            }

            if($scope.editView) {
                // Emit the save connections
                $rootScope.$emit('saveEntryDateTimeData' + $scope.connections.id, $scope.connections);
            } else {
                var directiveName = 'date-and-time',
                    newScope = $scope.$new(true);

                // to display step 2
                $rootScope.activePlus = true;

                // load the journey
                $scope.connections.top = CANVAS_OPTS.canvasOptions.top;
                $scope.connections.left = CANVAS_OPTS.canvasOptions.left;
                $scope.connections.type = 'Entry';
                $scope.connections.elemClass = {'dateAndTime': 'date-and-time'};
                $scope.connections.elemName = 'DateAndTime';
                $scope.connections.color = '#4F4FC9';
                $scope.connections.isRoot = true;
                $scope.connections.isElegibleForUpdate = true;

                $timeout(function () {
                    $rootScope.cElement = $scope.connections;
                    $compile('<' + directiveName + '></' + directiveName + '>')(newScope);
                    $scope.connections.wasSave = true;
                }, 10);

                $timeout(function () {
                    $scope.connections.wasSave = false;
                }, 2000);
            }

            $scope.isAddToSegmentFormDisplayed = false;
            $scope.showTriggerPanelModal = false;
            $scope.hideJourney();
        };

        $scope.$on('updateDateFormCtrl', (evt, time) => {
            if($scope.connections && $scope.connections.data) {
                $scope.connections.data.time = time;
            }
        });
    }
})();



// WEBPACK FOOTER //
// ./app/controllers/entryModalController.js